import React, {useMemo, useRef} from 'react';
import {DirectionalLight, LightProbe} from 'three';
import {Vector3} from '@react-three/fiber';
import {useLightEstimate} from 'hooks';
import {POS_SKY} from 'lib';

interface IARCoreLightingProps {}

const ARCoreLighting = ({}: IARCoreLightingProps) => {
  const lightProbeElRef = useRef<LightProbe>(null);
  const directionalLightElRef = useRef<DirectionalLight>(null);
  const directionalLightAPos: Vector3 = useMemo(() => [POS_SKY.x + 10, POS_SKY.y, POS_SKY.z + 10], []);
  const directionalLightBPos: Vector3 = useMemo(() => [POS_SKY.x - 10, POS_SKY.y, POS_SKY.z - 10], []);
  useLightEstimate({lightProbeElRef, directionalLightElRef});
  return (
    <>
      <lightProbe ref={lightProbeElRef} intensity={0} />
      <directionalLight intensity={0.5} position={directionalLightAPos} />
      <directionalLight intensity={0.5} position={directionalLightBPos} />
      <directionalLight
        ref={directionalLightElRef}
        intensity={0}
        position={POS_SKY}
        castShadow
        shadow-mapSize-width={4096}
        shadow-mapSize-height={4096}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}
      />
    </>
  );
};

export default React.memo(ARCoreLighting);
